import { InjectionToken } from '@angular/core';
import type { FeatureFlag } from '@sb/shared/feature';

/**
 * Pairs a feature flag with the query param that should be added to the URL
 * once that flag is enabled.
 */
export interface FeatureFlagQueryParam {
  featureFlag: FeatureFlag;
  key: string;
  value: string;
}

/**
 * The feature flags that surface themselves as a URL query param.
 *
 * Add an entry per flag you want reflected in the URL. When the flag is
 * enabled, `FeatureFlagQueryParamService` merges `{ [key]: value }` into the
 * current URL's query params.
 *
 * @example
 * export const featureFlagQueryParamMap = [
 *   { featureFlag: featureFlag.LABS_COMMAND_PALETTE, key: 'labs', value: 'true' },
 * ];
 */
export const featureFlagQueryParamMap: readonly FeatureFlagQueryParam[] = [];

/**
 * DI token exposing {@link featureFlagQueryParamMap}. Backed by the const above
 * by default; override it in tests to exercise the service with a fixed map.
 */
export const FEATURE_FLAG_QUERY_PARAMS = new InjectionToken<readonly FeatureFlagQueryParam[]>(
  'FEATURE_FLAG_QUERY_PARAMS',
  { providedIn: 'root', factory: () => featureFlagQueryParamMap },
);
